import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "@/pages/Home";
import AboutUs from "@/pages/AboutUs";
import OurTeam from "@/pages/OurTeam";
import ServicesPage from "@/pages/ServicesPage";
import DetailService from "@/pages/DetailService";
import PricingPlan from "@/pages/PricingPlan";
import Appointment from "@/pages/Appointment";
import ContactUs from "@/pages/ContactUs";
import FAQ from "@/pages/FAQ";
import Blog from "@/pages/Blog";
import SinglePost from "@/pages/SinglePost";
import Error404 from "@/pages/Error404";

const R = "/gb/en";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to={`${R}/home.html`} replace />} />
          <Route path={`${R}/home.html`} element={<Home />} />
          <Route path={`${R}/about-us.html`} element={<AboutUs />} />
          <Route path={`${R}/our-team.html`} element={<OurTeam />} />
          <Route path={`${R}/services.html`} element={<ServicesPage />} />
          <Route path={`${R}/detail-service.html`} element={<DetailService />} />
          <Route path={`${R}/pricing-plan.html`} element={<PricingPlan />} />
          <Route path={`${R}/appointment.html`} element={<Appointment />} />
          <Route path={`${R}/contact-us.html`} element={<ContactUs />} />
          <Route path={`${R}/faq.html`} element={<FAQ />} />
          <Route path={`${R}/blog.html`} element={<Blog />} />
          <Route path={`${R}/blog/:slug`} element={<SinglePost />} />
          <Route path={`${R}/404.html`} element={<Error404 />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
